import React from 'react';
import { CentroAlert } from '../types/centro.types';

interface CentroFormAlertProps {
    alert: CentroAlert | null;
    onDismiss: () => void;
}

export const CentroFormAlert: React.FC<CentroFormAlertProps> = ({ alert, onDismiss }) => {
    if (!alert) return null;

    return (
        <div className={`alert alert-${alert.type} shadow-sm border-0 alert-dismissible fade show`}>
            {alert.message}
            <button type="button" className="btn-close" onClick={onDismiss} aria-label="Cerrar" />
        </div>
    );
};
